<button type="button" (click)="onClick()" mat-mini-fab [color]="color" [disabled]="disabled"
    title="{{titleTranslateKey | translate}}">
    <span *ngIf="iconClass" class="fal fa-fw fa-material" [ngClass]="iconClass"></span>
</button>